// extracted by mini-css-extract-plugin
export default {"button":"Jl-z","reviewSort":"Kl-z"};